import { reaction } from 'mobx'
import { isFunction, debounce } from 'lodash';
import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react'
import { getMetaData, getTplId, pretreatment, isDesignPreview } from '../controllers'
import { err, setTitleToDocument } from '../util'
import YNFMetaRenderer from '@src/renderer/renderer-runtime/MetaRenderer'
import Skeleton from './Skeleton'
/**
 * 组件中通过props 获取值方便后续提供给外部使用
 */
export default function DynamicView(props) {
  const [pageData, setPageData] = useState({
    billNo: null,
    meta: null,
    appCode: null,
    notFound: null,
    params:{},
    query:{}
  })
  const { query, billNo } = props
  const rtcString = query?.rtc || props.params?.rtc
  let rtc
  try {
    rtc = JSON.parse(decodeURIComponent(rtcString))
  } catch (error) {
  }
  const [isShowSkeleton, setIsShowSkeleton] = useState(rtc?.sk !== 0)
  // 记录页面一些变量，比如tplId
  const pageParams = useRef({})

  const params = { ...query, ...props?.params, ...props?.history?.route?.location?.state }

  const loadMeta = async (refresh) => {
    if (!billNo) {
      setPageData({ notFound: 'billNo is null' })
      return
    }
    await pretreatment(billNo, query, params, pageParams)
    const meta = await getMetaData({ ...params, ...pageParams.current, billNo, refresh })
    updateMetaData(meta)
  }
  const updateMetaData = async (meta, refresh = false) => {
    if (!meta || typeof meta == 'string') {
      err(meta)
      setPageData({ notFound: meta || 'meta is null' })
      return
    }
    pageParams.current.tplId = meta.tplId;
    pageParams.current.businessStepInfo = meta.businessStepInfo;
    setTitleToDocument(meta.caption);
    const newPageInfo = parseParams(meta)
    setPageData({
      meta,
      appCode: meta?.appCode,
      billNo: billNo,
      domainKey: params.domainKey,
      key: billNo + refresh ? new Date() : '1',
      params: newPageInfo.params,
      query: newPageInfo.query
    })
  }

  /**
   * 进行渲染原数前 补充一下默认的页面参数，原来到处在处理页面参数
   * @param {*} meta
   */
  const parseParams = (meta) => {
    // 详情页的 busiObj 如果与列表不一致，则在返回的模版 meta 信息获取最新的 busiObj 并更新 query
    return { params: { billName: meta.caption }, query: { busiObj: meta.busiObj } }
  }

  useEffect(() => {
    loadMeta(params?.noCacheMeta)
    props.history.refresh = async () => loadMeta(true)

  }, [billNo, params?.noCacheMeta])

  useEffect(() => {
    // 切换ui模板的方法，queryParams有三个属性: businessStepCode, orgId, orgIdName, transTypeId
    props.history.reloadUITemplate = async (queryParams = {}, forceUpdate = true) => {
      // 预览态不切模板
      if (isDesignPreview()) return false
      const { tplId, data } = await getTplId(billNo, { ...params, ...queryParams })
      const update = forceUpdate || pageParams.current.tplId !== tplId

      // 如果主组织变化，但模板不需要切换的时候，交易类型需要手动清空
      if (queryParams.orgReload && pageParams.current.tplId === tplId) {
        queryParams.transTypeId = ''
        queryParams.transTypeIdName = ''
      }

      pageParams.current = {
        ...pageParams.current,
        tplId,
        businessStepInfo: data?.businessStepInfo || [],
        ...queryParams
      }
      if (update) {
        const meta = await getMetaData({ ...params, ...pageParams.current, billNo })
        updateMetaData(meta)
      }
      return {
        update,
        pageParams: pageParams.current
      }
    }
  }, [])

  const onRootStoreCreated = useCallback((...args) => {
    isFunction(props.onRootStoreCreated) && props.onRootStoreCreated(...args)
    const rootStore = args[0]
    reaction(
      () => rootStore.ready,
      () => {
        setIsShowSkeleton(false)
      }
    )
  })

  return (
    <Fragment>
      <Skeleton terminalType={query.terminalType} loading={isShowSkeleton}>
        { billNo === pageData.billNo && <Fragment key={pageData.key}>
          <YNFMetaRenderer
            meta={pageData.meta}
            domainKey={pageData.meta?.domainKey || pageData.domainKey}
            query={{...query, ...pageData.query}}
            onRootStoreCreated={onRootStoreCreated}
            history={props.history}
            params={{ ...params, appCode: pageData.appCode, billNo: pageData.billNo, ...pageParams.current, diworkParams: props.diworkParams, ...pageData.params }}
          />
        </Fragment> }
      </Skeleton>
    </Fragment>
  )
}
